import { onboardingApi } from '@mathflat/domain/Onboarding'

import { openLink } from '@/utils/common'
import { toastError } from '@/utils/toast'

/**
 * 온라인 온보딩(아카데미) SSO 랜딩으로 이동한다.
 *
 * 서버가 SSO 토큰을 붙인 redirectUrl 을 내려주며(미전달 시 디폴트 랜딩),
 * 실패 시 토스트로 안내한다.
 */
export const openOnlineOnboardingLink = async () => {
  try {
    const { redirectUrl } = await onboardingApi.getOnlineOnboardingRedirect()
    openLink(redirectUrl)
  } catch {
    toastError('연결에 실패했어요. 잠시 후 다시 시도해주세요.')
  }
}
